export default __webpack_public_path__ + "c3caf4ae411f2f20372f2784f7cb1603.svg";